import React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import { Icon as NeoIcon } from '@locus-taxy/neo-ui';

import { FontIcon } from 'react-toolbox/lib/font_icon';
import { TooltipButton, ButtonTypes } from 'common/components/core/button';
import { copyLinkFactory } from 'common/components/core/link/CopyLink';
import Tooltip from 'common/components/core/tooltip';
import theme from './CopyButton.scss';
const TooltipFontIcon = Tooltip(FontIcon);

class CopyComponent extends React.Component {
    static defaultProps = {
        iconSize: NeoIcon.Size.medium
    };

    render() {
        const {
            theme,
            onClick,
            isCopied,
            copyTooltip,
            showNewIcon,
            iconSize
        } = this.props;
        const tooltipText = isCopied ? (
            <span className={theme.copySuccessWrap}>
                <FontIcon
                    className={classnames(
                        theme.copiedIcon,
                        'ml-icon',
                        'tickmark'
                    )}
                />
                <span>Copied</span>
            </span>
        ) : (
            copyTooltip
        );
        return (
            <>
                {!showNewIcon ? (
                    <TooltipFontIcon
                        tooltipPosition="right"
                        tooltipHideOnClick={false}
                        tooltip={tooltipText}
                        className={classnames(
                            theme.copyButton,
                            'ml-icon',
                            'duplicate'
                        )}
                        onClick={onClick}
                        theme={theme}
                    />
                ) : (
                    <TooltipButton
                        invert
                        tooltipPosition="right"
                        tooltipHideOnClick={false}
                        ripple={false}
                        tooltip={tooltipText}
                        buttonType={ButtonTypes.Icon}
                        onClick={onClick}
                        theme={theme}
                    >
                        <NeoIcon icon="copy_content" size={iconSize} />
                    </TooltipButton>
                )}
            </>
        );
    }
}

const themedCopyComponent = themr('CopyComponent', theme)(CopyComponent);
const CopyContentButton = copyLinkFactory({
    CopyComponent: themedCopyComponent
});

export default CopyContentButton;
